import { observable } from 'mobx'
import Api from '@api/xi_feng/newCustomer'

class Store {
  @observable visible = false
  @observable selected = []
  @observable supportList = []

  constructor(detailStore) {
    this.detailStore = detailStore
  }

  setStoreData = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })
  }

  add = value => {
    this.selected.push(value)
  }

  remove = value => {
    this.selected = this.selected.filter(item => item.id !== value.id)
  }

  getSupportList = async () => {
    const { data } = await Api.getStaffList()
    this.supportList = data || []
  }

  addSupport = async () => {
    const { success } = await Api.addSupport({
      merchant_customer_id: this.detailStore.id,
      support_ids: this.selected.map(item => item.id).toString()
    })

    if (success) {
      this.setStoreData({ visible: false })
      this.detailStore.refresh()
    }
  }
}

export default Store
